import React, { Fragment, useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { authContext } from "../../context/AuthContext";

import withStyles from '@mui/styles/withStyles';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import AlertTitle from '@mui/material/AlertTitle';
import Alert from '@mui/material/Alert';

import axios from 'axios';
import Loading from '../helper/Loading';
import moment from 'moment';
import { Button } from '@mui/material';
import { Trans } from 'react-i18next';
import { trainingCost } from '../../constants/global'

const styles = theme => ({
  root: {
    '& a': {
      color: 'white'
    }
  },
  card: {
    height: '100%',
  },
  media: {
    height: 200,
  },
});

//{ id, label, modules }

// CURRENT
/*
1. Check if expired, or passed -> if so, display buttons for training options
2. If blocked -> display message about course expired, wait 6 months
3. If course available -> display resume button
4. If no course but credit -> display buttons for training options
5. if no credit -> purchase credit buttons
*/

// NOT USED
// possible order of precedence if expiration //  not used currently as courses don't expire
/*

1. Check if most recent training expired
  a). Check if most recent training expired and not passed/blocked -> if so display expired alert along with purchase buttons
  b) if expired and passed -> same as above
  c) if expired and blocked -> same as above
2. if not expired:
  a). Check if the training is passed -> display alert that says training passed, along with purchase buttons
  b). Check if most recent trianing blocked -> display needing to take in person, no buttons
  c) Check if there is an in-progress training -> display resume button
3. No training and credit >= trainingCost -> display training option buttons
4. No credit -> display purchase credit buttons
*/

function TrainingMain(props) {
  const { t, classes } = props;
  const user = useContext(authContext).user
  const username = user.username
  const history = useHistory()

  const [credit, setCredit] = useState(null)
  const [currentTraining, setCurrentTraining] = useState(null)
  const mounted = useRef(true)

  useEffect(() => {
    async function fetchData() {
      const res = await axios.all([
        axios.get('/api/user/credit/' + username),
        axios.get('/api/userTraining/latest/' + username)
      ])

      let training = res[1].data.training
      const trainingExt = res[1].data.trainingExt  // trainingExt mainly used for serial number
      const serialNum = trainingExt && trainingExt.serialNumber
      console.log(training);
      // grab the max score and number of tests. Do not show the most recent if at least one score is >= 75, or if two scores <75
      const courseTests = res[1].data.tests
      let maxScore, passed, blocked
      let showRecent = true
      // comment the below if statement if want to show the most recent even if passed/blocked
      if(courseTests){
        maxScore = Math.max(...courseTests.map(e => e.score))
        passed = maxScore >= 75
        blocked = maxScore < 75 && courseTests.length >= 2
        showRecent = !(passed || blocked)
      }

      console.log(serialNum)

      let courseData
      if (training) {
        const res2 = await axios.get('/api/course/' + training.courseId)
        courseData = { ...res2.data }
        console.log("COURSE", training, courseData)
      }

      if (mounted.current) {
        setCredit(res[0].data.user.credit)
        // setLoading(false)
        if (courseData) {
          const usedBy = moment(training.usedBy);
          const timeLeft = usedBy.diff(moment(), 'days')
          const expired = timeLeft < 0
          console.log(training.id);
          // console.log("Time", regTime6Mo, timeLeft)
          setCurrentTraining({ showCurrent: showRecent, blocked, serialNum, realID: training.id, expired, disabled: training.disabled,
            expires: usedBy.format('YYYY-MM-DD'), timeLeft, certLink: courseData.course.postTestLink, 
            regDate: training.registerDate, type: training.type, trainingId: training.id, courseID: courseData.course.id, 
            label: courseData.course.label, modules: courseData.modules })
        }
      }
    }

    fetchData()

    return () => mounted.current = false


  }, [username])

  const addCredit = () => {
//    history.push('/dashboard/user/' + username + '/addCredit', { from, })
        history.push('/dashboard/user/' + username + '/addCredit', {credit: credit})

  }

  const onEmployerClick = () => {
    history.push('/dashboard/trainingByEmployer');
  }

  const onOnlineTraining = () => {
    // history.push('/courses?type=' + from, { credit, });
    history.push('/courses/Online', { credit, });

  }

  const onDVDTraining = () => {
   // history.push('/courses/DVD/code', { credit, });
       history.push('/courses/DVD', { credit, });

  }

  const onZoomTraining = () => {
    //history.push('/courses/Zoom/code', { credis, });
        history.push('/courses/Zoom', { credit, });

  }

  const onResume = () => {
    const { courseID: id, label, modules, type, trainingId, certLink, serialNum } = currentTraining
    console.log("Current", currentTraining, id, label, modules)
    history.push('/training', { id, label, modules, type, trainingId, certLink, serialNum })
  }

  // goes to affadivit then comes back
  const onTransform = (typeName) => {
    const { courseID: id, label, realID, type} = currentTraining
    console.log("Current course",currentTraining, currentTraining.id, currentTraining.courseID)

    // in this case, id is the courseID, realID is the unique id

    const lang = (id === '3959206') ? 'English' : 'Spanish'
    history.push('/courses/' + typeName + '/code', { type, realID, id, lang, label, transform: true })
  }

  return (
    <Fragment>
      <Box pb={1} mt={4} mb={4} borderBottom={1} borderColor="#E0E0E0">
        <h3 className="page-heading">{t('training.title') + user.name + t('training.titleCheck')}</h3>
        <ul>
          <li>{ t('training.subTitle1')}</li>
          <li>{ t('training.subTitle2')}</li>
        </ul>
      </Box>

      {currentTraining && currentTraining.showCurrent && !currentTraining.expired && !currentTraining.disabled ? <>
        <h3>{currentTraining.label}</h3>
        {/* <p>Time until course expires: {currentTraining.timeLeft} days.</p> */}
        <p> {t('trainingMain.ExpirationDate') + ": " + currentTraining.expires}</p>
        <p> {t('trainingMain.TrainingType') + ": " + currentTraining.type}</p>
        <Button onClick={onResume} variant="contained" color="primary" > {t('trainingMain.ResumeTraining')} </Button>
        {currentTraining.type === "Online" && <Button style={{ marginLeft: "2em" }} onClick={() => onTransform("DVD")} variant="outlined" color="primary" > {t('trainingMain.ConvertToDVD')} </Button>}
        {currentTraining.type === "Online" && <Button style={{ marginLeft: "2em" }} onClick={() => onTransform("Zoom")} variant="outlined" color="primary" > {t('trainingMain.ConvertToZoom')} </Button>}
        
        <hr />

        <br />

      </>

        : currentTraining && currentTraining.blocked && !currentTraining.expired? // if its blocked, it will show this message until it expires
        <>
          <p> <Trans
            i18nKey={"trainingMain.TrainingFailed"}
            components={[<a href="/classes">placeholder</a>]}
          />  </p> 
          {credit >= trainingCost ?
            <TrainingCard
                  go
              title={ t('trainingMain.CreditEnough.TrainingCards.ZoomTraining') }
              detail1={ t('trainingMain.CreditEnough.TrainingCards.ZoomTrainingDetail1') }
              detail2={ t('trainingMain.CreditEnough.TrainingCards.ZoomTrainingDetail2') }
              detail3={ t('trainingMain.CreditEnough.TrainingCards.ZoomTrainingDetail3') }
              detail4={ t('trainingMain.CreditEnough.TrainingCards.ZoomTrainingDetail4') }
              onClick={onZoomTraining}
              classes={classes}
            />
            :
             <>
              <Grid container direction="row" justifyContent="space-around" alignItems="center">
                <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    className={[].join(' ')}
                    onClick={addCredit}
                    >
                    {t('mytraining.title')}
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    className={[].join(' ')}
                    onClick={onEmployerClick}
                    >
                    {t('myEmpTraining.title')}
                </Button>
                </Grid>
            </>
          }
        </>
        : 

        <Grid container spacing={3}>
          {credit === null ? <Loading /> // if credit is null (still loading in credit, display loading)
            :
            (credit >= trainingCost) ?
              <>
                <Alert style={{ width: '100%' }}>
                  <AlertTitle> {t('trainingMain.CreditEnough.ProceedToTrainingOrTesting')}  </AlertTitle>
                  {t('trainingMain.CreditEnough.YouHave')}  ${credit} {t('trainingMain.CreditEnough.YourCredit')}
                </Alert>
                <TrainingCard
                  go
                  title={ t('trainingMain.CreditEnough.TrainingCards.OnlineTraining') }
                  detail1={ t('trainingMain.CreditEnough.TrainingCards.OnlineTrainingDetail1') }
                  detail2={ t('trainingMain.CreditEnough.TrainingCards.OnlineTrainingDetail2') }
                  detail3={ t('trainingMain.CreditEnough.TrainingCards.OnlineTrainingDetail3') }
                  detail4={ t('trainingMain.CreditEnough.TrainingCards.OnlineTrainingDetail4') }
                  onClick={onOnlineTraining}
                  classes={classes}
                />
                <TrainingCard
                  go
                  title={t('trainingMain.CreditEnough.TrainingCards.DvdTraining')}
                  detail1={t('trainingMain.CreditEnough.TrainingCards.DvdTrainingDetail1')}
                  detail2={t('trainingMain.CreditEnough.TrainingCards.DvdTrainingDetail2')}
                  detail3={t('trainingMain.CreditEnough.TrainingCards.DvdTrainingDetail3')}
                  detail4={t('trainingMain.CreditEnough.TrainingCards.DvdTrainingDetail4')}
                  onClick={onDVDTraining}
                  classes={classes}
                />
                <TrainingCard
                  go
                  title={ t('trainingMain.CreditEnough.TrainingCards.ZoomTraining') }
                  detail1={ t('trainingMain.CreditEnough.TrainingCards.ZoomTrainingDetail1') }
                  detail2={ t('trainingMain.CreditEnough.TrainingCards.ZoomTrainingDetail2') }
                  detail3={ t('trainingMain.CreditEnough.TrainingCards.ZoomTrainingDetail3') }
                  detail4={ t('trainingMain.CreditEnough.TrainingCards.ZoomTrainingDetail4') }
                  onClick={onZoomTraining}
                  classes={classes}
                />
              </>
              :
              <>
                <Alert severity="warning" style={{ width: '100%' }}>
                  <AlertTitle> {t('trainingMain.NoCredit.PleasePurchase')}  </AlertTitle>
                  {t('trainingMain.NoCredit.YouHave')} ${credit} {t('trainingMain.NoCredit.YourCredit')}
                </Alert>
               <Grid container direction="row" justifyContent="space-around" alignItems="center"  >
                <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    className={[].join(' ')}
                    onClick={addCredit}
                    >
                    {t('mytraining.title')}
                </Button>
               
                <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    className={[].join(' ')}
                    onClick={onEmployerClick}
                    >
                    {t('myEmpTraining.title')}
                </Button>
                </Grid>
                  
                 <Alert severity="info" style={{ width: '100%' }}>
                  <AlertTitle> {t('training.information')}  </AlertTitle>
                  <div>
                  <ul>
                    <li>{t('training.onlineInfo')}</li>
                    <li>{t('training.dvdInfo')}</li>
                    <li>{t('training.zoomInfo')}</li>
                  </ul>
                  <Button href="https://ffl.ifas.ufl.edu/gi-bmp-training-help/select-training-or-test/" variant="contained" color="primary" > {t('training.moreInfo')} </Button>
                  </div>
              </Alert>
              </>
             
          }
        </Grid>

      }
    </Fragment >
  );
}

function TrainingCard(props) {
  const { classes } = props;

  return (
    <Grid item xs={12} sm={6} md={props.go ? 4 : 6}>
      <Card className={[classes.root, classes.card].join(' ')} >
        <CardActionArea onClick={props.onClick ? () => props.onClick(props.value) : null}>
          <CardContent className={classes.content}>
            <Typography gutterBottom variant="h5" component="h2" className={classes.title}>
              {props.title}
            </Typography>
            {props.detail1 &&
             <div>
                  <ul>
                   <Typography variant="body2" color="textSecondary" component="li">
                    {props.detail1}
                  </Typography>
                   <Typography variant="body2" color="textSecondary" component="li">
                    {props.detail2}
                  </Typography>
                   <Typography variant="body2" color="textSecondary" component="li">
                    {props.detail3}
                  </Typography>
                   <Typography variant="body2" color="textSecondary" component="li">
                    {props.detail4}
                  </Typography>
                  </ul>
               </div>
            }
          </CardContent>
        </CardActionArea>
      </Card>
    </Grid>
  );
}

export default withStyles(styles, { withTheme: true })(withTranslation()(TrainingMain));


//{t('trainingMain.BecauseFailed')} <a href="/classes"> {t('trainingMain.GoToZoom')} </a>  {t('trainingMain.RetakeTest')}